// Module
var code = `<div id="loading" class="hide"></div>
`;
// Exports
export default code;